import "./Button.scss";

import React, { FC, useMemo } from "react";

export interface ButtonProps {
  type?: any;
  children: unknown;
  uppercase?: boolean;
  inverse?: boolean;
  solid?: boolean;
  shortPadding?: boolean;
  isLink?: boolean;
  href?: string;
  clickHandler?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  mouseEnterHandler?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  mouseLeaveHandler?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  isDisabled?: boolean;
  isTargetBlank?: boolean;
}

const Button: FC<ButtonProps> = ({
  type,
  children,
  uppercase,
  inverse,
  solid,
  shortPadding,
  isLink,
  href,
  clickHandler,
  mouseEnterHandler,
  mouseLeaveHandler,
  isDisabled,
  isTargetBlank,
}) => {
  const classes = useMemo(() => {
    const classBase = "button";
    const computedClasses = [classBase];

    if (uppercase) {
      computedClasses.push(`${classBase}--uppercase`);
    }

    if (inverse) {
      computedClasses.push(`${classBase}--inverse`);
    }

    if (solid) {
      computedClasses.push(`${classBase}--solid`);
    } 

    if (shortPadding) {
      computedClasses.push(`${classBase}--short-padding`);
    }

    return computedClasses.join(" ");
  }, [uppercase, inverse]);

  if (isLink) {
    return (
      <a
        href={href}
        className={classes}
        target={isTargetBlank ? '_blank' : undefined}
        onMouseEnter={mouseEnterHandler}
        onMouseLeave={mouseLeaveHandler}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type={type ? type : "button"}
      className={classes}
      onClick={clickHandler}
      onMouseEnter={mouseEnterHandler}
      onMouseLeave={mouseLeaveHandler}
      disabled={isDisabled}
    >
      {children}
    </button>
  );
};
export default Button;
